import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SpreadProfileAction } from '../spreadProfile.action';

type IDependencies = IClientApiDependencySegment;

export const updateSpreadProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(SpreadProfileAction.update.started),
  mergeMap(({ params, reject }) => {
    return dependencies.api.updateSpreadProfile(params).pipe(
      mergeMap(() => {
        return [
          SpreadProfileAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          SpreadProfileAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
